import { CSSProperties } from "react";

export default class DialogMultilineTextInputViewStyle {

    textField: CSSProperties = {
        marginTop: 10,
        fontWeight: 300,
        fontFamily: 'Roboto'
    }

    input: CSSProperties = {
        fontSize: 15,
        color: '#405364',
        fontWeight: 300,
        fontFamily: 'Roboto'
    };
}